

/**
 * Travel itinerary draft entry in Create Design dialog.
 * Enabled by default; set REACT_APP_ITINERARY_DRAFT_ENABLED=false to hide.
 */
export function isItineraryDraftEntryEnabled() {
  const raw = String(process.env.REACT_APP_ITINERARY_DRAFT_ENABLED ?? 'true')
    .trim()
    .toLowerCase();
  return raw !== 'false' && raw !== '0' && raw !== 'no';
}
